import React, { useContext } from 'react';

import { CursorContext } from '../context/CursorContext';

import MobileNav from './MobileNav';

import { Link } from 'react-router-dom';

const Header = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <header
      className="fixed w-full px-[40px] lg:px[100px] z-30 
  h-[100px] lg:h-[140px] flex items-center "
    >
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Link
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          to={'/'}
          className="max-w-[100px]"
        >
          <h2 className="text-xl">Kameshwaran</h2>
        </Link>

        <nav
          className="hidden xl:flex gap-x-12 font-semibold text-xl"
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
        >
          <Link
            to={'/'}
            className="text-[#696c6d] hover:text-primary transition"
          >
            Home
          </Link>
          <Link
            to={'/about'}
            className="text-[#696c6d] hover:text-primary transition"
          >
            About
          </Link>
          <Link
            to={'/skills'}
            className="text-[#696c6d] hover:text-primary transition"
          >
            Skills
          </Link>
          <Link
            to={'/portfolio'}
            className="text-[#696c6d] hover:text-primary transition"
          >
            Projects
          </Link>
          <Link
            to={'/contact'}
            className="text-[#696c6d] hover:text-primary transition"
          >
            Contact Me
          </Link>
        </nav>
      </div>
      <MobileNav />
    </header>
  );
};

export default Header;
